import React, { createContext } from 'react'

export const GeneralContext = createContext({
  options: null, additionalData: null
})

const GeneralProvider = ({
  options,
  page,
  scenarios,
  services,
  children
}) => (
  <GeneralContext.Provider
    value={{
      options,
      page,
      scenarios,
      services,
    }}
  >
    {children}
  </GeneralContext.Provider>
)

export default GeneralProvider
